import { environment } from 'environments/environment';
import { Injectable } from '@angular/core';
import { LogLevel } from '@logs/models/log-level.enum';

@Injectable()
export class LogService {
  private defaultLogLevel: LogLevel = LogLevel.Info;

  public log(message: string, logLevel?: LogLevel): void {
    if (!logLevel) {
      logLevel = this.defaultLogLevel;
    }

    switch (logLevel) {
      case LogLevel.Critical:
      case LogLevel.Error:
      case LogLevel.Warning:
        this.doLog(this.formatMessage(logLevel, message), true);
        break;
      default:
        this.doLog(this.formatMessage(logLevel, message), false);
        break;
    }
  }

  public logVerbose(message: string): void {
    this.log(message, LogLevel.Verbose);
  }

  public logDebug(message: string): void {
    this.log(message, LogLevel.Debug);
  }

  public logInfo(message: string): void {
    this.log(message, LogLevel.Info);
  }

  public logWarning(message: string): void {
    this.log(message, LogLevel.Warning);
  }

  public logError(message: string): void {
    this.log(message, LogLevel.Error);
  }

  public logCritical(message: string): void {
    this.log(message, LogLevel.Critical);
  }

  private doLog(formattedMessage: string, error: boolean): void {
    if (environment.production) {
      return;
    }

    if (error) {
      console.error(formattedMessage);
    } else {
      console.log(formattedMessage);
    }
  }

  private getIsoDate(): string {
    return new Date().toISOString();
  }

  private getLogLevelName(logLevel: LogLevel): string {
    return LogLevel[logLevel];
  }

  private formatMessage(logLevel: LogLevel, message: string): string {
    return `${this.getIsoDate()} [${this.getLogLevelName(logLevel)}]: ${message}`;
  }
}
